<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getRockeys">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addRockey">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="rockeys" highlight-current-row v-loading="listLoading" style="width: 100%" @sort-change="sortchange" :height="bodyHeight-220">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="sn" label="加密锁编号" min-width="120" sortable="custom">
      </el-table-column>
      <el-table-column prop="user" label="使用者" min-width="150" sortable="custom">
      </el-table-column>     
      <el-table-column prop="status" label="状态" width="100" align="center" :formatter="formatStatus" sortable="custom">
        <template scope="scope">
          <i :class="formatStatusIcon(scope.row)"></i>
          {{formatStatus(scope.row)}}
          </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建日期" width="180" sortable="custom" :formatter="formatdatetime">
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template scope="scope">
          <el-button size="small" @click="editRockey(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="delRockey(scope.$index, scope.row)">删除</el-button>          
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>

    <!--新增界面-->
    <el-dialog :title="rockeyTitle" :visible="addFormVisible" :close-on-click-modal="false" size="small" top="10px">
      <div v-bind:style="{ height: '200px' , overflowY: 'auto' }">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">        
        <el-form-item label="加密锁编号" prop="sn">
          <el-input v-model="addForm.sn"></el-input>
        </el-form-item>
        <el-form-item label="使用者" prop="user">
          <el-input v-model="addForm.user"></el-input>
        </el-form-item>       
      </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="saveRockey" :loading="addLoading">保存</el-button>
        <el-button @click.native="addFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

  </section>
</template>
<style>
  .el-input-group .el-select .el-input{
    width:90px;
  }
  i.Blue {
    color:#20A0FF
  }
  i.Success {
    color:#13CE66
  }
  i.Warning {
    color:#F7BA2A
  }
  /* .el-dialog__body {
    height: 600px;
    overflow-y:auto;
  } */
</style>

<script>
export default {
  name: 'rockeyManage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      listLoading: false,
      sortname: 'createdate',
      sorttype: 'desc',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      tableheight: window.innerHeight - 220,
      rockeys: [
      ],
      logVisible: false,
      rockeyTitle: '新增',
      isEditModel: false,
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        sn: [
          { required: true, message: '请输入加密锁编号', trigger: 'change' }
        ],
        user: [
          { required: true, message: '请输入使用者', trigger: 'change' }
        ]
      },
      // 新增界面数据
      addForm: {
        rockeyId: 0,
        sn: '',
        user: ''
      },
      serverLoading: false
    }
  },
  methods: {
    formatdatetime: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    formatdate: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd')
    },
    // 显示转换
    formatStatus: function(row) {
      if (row.status === -1) {
        return '删除'
      } else if (row.status === 0) {
        return '正常'
      } else if (row.status === 1) {
        return '停用'
      } else {
        return '未知'
      }
    },
    // 显示图标
    formatStatusIcon: function(row) {
      if (row.status === -1) {
        return 'el-icon-loading Blue'
      } else if (row.status === 0) {
        return 'el-icon-circle-check Success'
      } else if (row.status === 1) {
        return 'el-icon-warning Warning'
      } else {
        return 'el-icon-info'
      }
    },
    // 获取加密锁列表
    getRockeys: function() {
      let para = {
        keywords: this.filters.keywords,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }

      this.$ajax({
        url: 'api/Rockey/GetRockeys',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.rockeys = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    pageChange: function(val) {
      this.pageno = val
      this.getRockeys()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getRockeys()
    },
    addRockey: function() {
      this.rockeyTitle = '加密锁新增'
      this.isEditModel = false
      this.addFormVisible = true
      this.addForm = {
        rockeyId: 0,
        sn: '',
        user: ''
      }
      this.$refs.addForm.resetFields()
    },
    saveRockey: function() {
      let url = 'api/Rockey/SaveRockey'
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm)
          this.$ajax({
            url: url,
            data: JSON.stringify(para),
            loadingName: 'addLoading',
            success: (response) => {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              })
              this.$refs['addForm'].resetFields()
              this.addFormVisible = false
              this.getRockeys()
            }
          })
        }
      })
    },
    serverChange: function(s, s1) {

    },
    editRockey: function(index, row) {
      this.addFormVisible = true
      this.rockeyTitle = '加密锁编辑'
      this.isEditModel = true
      this.addForm = Object.assign({}, row)
      this.$refs.addForm.resetFields()
    },
    delRockey: function(index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = [row.rockeyId]
        this.$ajax({
          url: 'api/Rockey/DeleteRockeys',
          data: JSON.stringify(para)
        }).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getRockeys()
        })
      }).catch(() => {
      })
    }
  },
  mounted() {
    this.getRockeys()
    window.onresize = () => {
      return (() => {
        this.tableheight = window.innerHeight - 220
      })()
    }
  }
}
</script>